import Alert from '@web/components/Modal/Alert'
import { useModal } from '@web/components/Modal/useModal'
import useNAppScheme from '@web/hooks/useNAppScheme'
import links from '@web/libs/constants/links'
import routes from '@web/libs/constants/routes'
import nClicks from '@web/libs/nlog/click/codes'

const useOpenNaverAppClipModal = () => {
  const { getNAppURLScheme } = useNAppScheme()

  const { openModal } = useModal(Alert, {
    label: {
      confirm: '네이버 앱 열기',
      cancel: '취소',
    },
    title: (
      <>
        네이버 앱에서
        <br />
        클립을 사용해 보세요!
      </>
    ),
    callback: {
      confirm: () => {
        window.location.href = getNAppURLScheme(`${links.MY_HOME}${routes.CHECKIN}?openClipEditor=true`)
      },
    },
    clickCodes: {
      confirm: nClicks.checkin.CLIP_NAVER_POPUP_O,
      cancel: nClicks.checkin.CLIP_NAVER_POPUP_X,
    },
  })

  return { openModal }
}

export default useOpenNaverAppClipModal
